export const environment = {
  production: true,
  login_service_url:"%%LOGIN_SERVICE_URL%%",
  crossDomainUrl:"%%CROSS_DOMAIN_COOKIE_URL%%",
  adminToolUrl: "%%ADMIN_TOOL_URL%%",
  cdnUrl:"%%CDN_URL%%",
  environmentName: "%%ASPNETCORE_ENVIRONMENT%%",
  issuer: '%%%BASE_URL%',
  clientId: '%%CLIENT_ID%%',

};
